import { useQuery } from '@tanstack/react-query';
import { apiListMvrRequestReports } from 'api';
import type { MVRReportListFilters } from 'api';

export const useMvrRequestList = (page = 0, filters?: MVRReportListFilters) => {
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['mvr-request-reports', page, filters],
    queryFn: () => apiListMvrRequestReports(page + 1, filters),
  });

  return {
    reports: data?.results ?? [],
    reportsCount: data?.count ?? 0,
    isLoadingReports: isLoading,
    isRefreshingReports: isFetching && !isLoading,
    reportsError: error,
    refetchReports: refetch,
  };
};
